import {Grid, Typography} from "@material-ui/core";
import jpgIcon from '../../../../../assets/images/jpgIcon.svg';
import pdfIcon from '../../../../../assets/images/pdfIcon.svg';
import React from "react";
import TextOverflow from "../../../../TextOverflow";
const bytesToMegaBytes = (bytes, digits) => digits ? (bytes / (1024*1024)).toFixed(digits) : (bytes / (1024*1024));

const UploadedFileItem = ({file, classes, onView, onDownload}) => {


    return (
            <Grid item container direction="row" alignItems="center" className={classes.uploadFileItem}>
                <Grid item xs={1} >
                    {
                        file?.mimeType === 'application/pdf' ?
                            <img src={pdfIcon} width="35px"/> :
                            <img src={jpgIcon} width="35px"/>
                    }
                </Grid>
                <Grid item container direction="column"  className={classes.fileInfo} xs={4}>
                    <Grid item className={classes.uploadedFileName} >
                        <TextOverflow>{file.name}</TextOverflow>
                    </Grid>
                    <Grid item className={classes.uploadedFileName}>
                        <Typography>{bytesToMegaBytes(file.size,2)} MB</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <i style={{fontSize: 22, color: '#000000', cursor: 'pointer', margin: '0 3px'}} className={'fa  fa-eye'} onClick={onView}/>
                </Grid>
                <Grid item xs={1}>
                    <i style={{fontSize: 22, color: '#000000', cursor: 'pointer', margin: '0 3px'}} className={'fa fa-download'} onClick={onDownload}/>
                </Grid>
            </Grid>
    );

}
export default UploadedFileItem;